import { FCX } from "@datassential/platform-ui-lib";
import { highlightMatches } from "@core/helpers";
import LineEllipsis from "@components/LinesEllipsis/LinesEllipsis";

export const TitleCell: FCX<{ 
    value?: string | null; 
    searchQuery: string; 
}> = ({ value, searchQuery }) => (
    <div
        dangerouslySetInnerHTML={{
            __html: highlightMatches(value || '', searchQuery)
        }}
    />
);

export const DescriptionCell: FCX<{ 
    value?: string | null; 
    searchQuery: string;
    rowHeight: number;
}> = ({ value, searchQuery, rowHeight }) => (
    <LineEllipsis lines={2} rowHeight={rowHeight}>
        {highlightMatches(value || '', searchQuery)}
    </LineEllipsis>
);

export const DateCell: FCX<{ value: string }> = ({ value }) => (
    <>{value}</>
);

export const CompanyCell: FCX<{ 
    value?: string | null; 
    children?: React.ReactNode;
}> = ({ value, children }) => (
    <>
        {value}
        {children}
    </>
);
